import type { AuthContextType } from '@context/auth.context';
import type { TelegramUser } from '@interfaces/telegram-user';
import { actionRequest } from '@services/action-request';
import type { ActionFunction } from 'react-router-dom';

export enum ACTIONS {
  Update = 'update',
  Notify = 'notify-telegram-on-user-keyboard',
  ResyncAssociations = 'resync-associations',
}

export const action = (auth: AuthContextType) =>
  (async ({ request }) => {
    const { intent, ...data } = await request.json();

    switch (intent) {
      case ACTIONS.Update: {
        const { id: userId, ...rest } = data;
        return await actionRequest<TelegramUser>(auth, request, `manage/telegram-user/${userId}`, rest, {
          throwOnGenericErrors: false,
        });
      }
      case ACTIONS.Notify:
        return await actionRequest<Response>(
          auth,
          request,
          `manage/telegram/user-keyboard-change`,
          data.userIds as number[],
          { throwOnGenericErrors: false },
        );
      case ACTIONS.ResyncAssociations: {
        return await actionRequest<Response>(auth, request, `manage/telegram-group/resync-user-associations`);
      }
      default:
        throw new Error(`Undefined intent '${intent}' for the action`);
    }
  }) satisfies ActionFunction;
